// All comments in English.
export default function ErrorState({ text = "Something went wrong" }: { text?: string }) {
  return <div className="p-6 text-center text-sm text-red-600">{text}</div>;
}
